import { HTMLAttributes } from "react";

interface ClubsAndTeamsIconProps extends HTMLAttributes<SVGElement> {}

const ClubsAndTeamsIcon = ({}: ClubsAndTeamsIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
    >
      <path
        d="M5 37V26.9647M5 26.9647C15.9087 18.3704 24.0913 35.5588 35 26.9647V5.48095C24.0913 14.0752 15.9087 -3.11332 5 5.48095V26.9647Z"
        stroke="#048CDD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ClubsAndTeamsIcon;
